import { apiClient } from './apiClient';

export interface TermsPayload {
    version: string;
    content: string;
}

export const termsService = {
    async get(): Promise<TermsPayload> {
        const { data } = await apiClient.get('/terms/');
        return { version: data.version, content: data.content };
    },
};

export default termsService;
